import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import type { MainPageClientData } from '../../../typings';

type MainPageResponseData = {
    page?: MainPageClientData;
};
export interface GetMainPageRequest {
    grade: number;
    date: string;
    role?: 'parent' | 'teacher' | 'student';
    experiments?: number[];
    is_public_blocks?: boolean;
    platform?: 'desktop_site' | 'mobile_site' | 'app';
}

export function getMainPage(req: GetMainPageRequest): Promise<MainPageResponseData> {
    const { apiGetMainPage } = apiConfig.getStaticUrls();

    return getFetch(apiGetMainPage, req);
}
